import { render, staticRenderFns } from "./cowshed.vue?vue&type=template&id=0ce026b4&scoped=true&"
import script from "./cowshed.vue?vue&type=script&lang=js&"
export * from "./cowshed.vue?vue&type=script&lang=js&"
import style0 from "./cowshed.vue?vue&type=style&index=0&id=0ce026b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce026b4",
  null
  
)

export default component.exports